import { useState, useEffect } from 'react';
import api from '../lib/api';

export default function OurStoryPage() {
  const [content, setContent] = useState(null);
  useEffect(() => { api.get('/settings/our_story').then(r => setContent(r.data)).catch(() => {}); }, []);
  if (!content) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" /></div>;

  return (
    <div data-testid="our-story-page">
      {content.hero_image && (
        <div className="relative h-72 sm:h-96">
          <img src={content.hero_image} alt="" className="w-full h-full object-cover" />
          <div className="hero-overlay absolute inset-0" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-medium text-white tracking-tight">{content.heading || 'Our Story'}</h1>
          </div>
        </div>
      )}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          <p className="text-lg text-muted-foreground leading-relaxed whitespace-pre-line">{content.content}</p>
        </div>
        {content.mission_heading && (
          <div className="mt-16 p-8 bg-secondary/30 rounded-3xl">
            <h2 className="text-2xl sm:text-3xl font-serif font-medium mb-4">{content.mission_heading}</h2>
            <p className="text-muted-foreground leading-relaxed">{content.mission_text}</p>
          </div>
        )}
      </div>
    </div>
  );
}
